module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-03-1e98cc0384a85a197ef089f3080cc4b4.png";